import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-more",
  "use": "app-more-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"app-more\"><defs><style>#app-more .cls-1{fill:#ccc}#app-more .cls-2{fill:#fff}</style></defs><title>资源 32</title><g id=\"app-more_图层_2\" data-name=\"图层 2\"><g id=\"app-more_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M0 0h50v50H0z\" /><path class=\"cls-2\" d=\"M25 10a15 15 0 1 0 15 15 15 15 0 0 0-15-15zm-6.5 17a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm6.5 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm6.5 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/app-more.svg
// module id = 9rRM
// module chunks = 6